import { type ZodSchema, z } from 'zod';

import type { DataOrError, Stringified } from '#utils/errorCheck.ts';
import { getZodNestedErrors } from '#utils/formErrors.ts';

import type { TourFormValues } from './NewTourFormState.ts';

const error = {
    SMALL_STRING: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.validation.small-string',
    LONG_STRING: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.validation.long-string',
    VEHICLE_REQUIRED: 'intl-msg:ordercom-cloud-frontend.orders.create-dialog.validation.selectTourTruck',
    ORDERS_REQUIRED: 'intl-msg:ordercom-cloud-frontend.tours.create-dialog.validation.select-orders',
};

export const TourFormValidation = z.object({
    tourNumber: z.string().min(1, error.SMALL_STRING).max(255, error.LONG_STRING),
    note: z.string().optional(),
    driver: z.string(),
    vehicle: z.string().nonempty(error.VEHICLE_REQUIRED),
    selectedOrderIds: z.array(z.string()).min(1, error.ORDERS_REQUIRED),
    maxWeightT: z.number().finite().min(0).optional(),
    maxLoadingMeter: z.number().finite().min(0).optional(),
    maxVolumeLiter: z.number().finite().min(0).optional(),
    maxVolumeCubicMeter: z.number().finite().min(0).optional(),
});

/**
 * Parses and validates the order form data using the provided schema.
 * the type of ErrorMap is inferred from the data type (might be better to use types from Schema but its already complicated enough)
 */
export const parseAndValidateTourFormValidation = <Data extends Record<string, unknown>>(
    data: Data,
    schema: ZodSchema = TourFormValidation
): DataOrError<TourFormValues, Partial<Stringified<Data>>> => {
    try {
        const parsed = schema.parse(data);
        return [parsed, null];
    } catch (e) {
        const validationErrors = getZodNestedErrors<Data>(e);
        return [null, validationErrors];
    }
};
